import { useSelector } from "react-redux";
import { Button } from "@mui/material"
import { LoadingAnimation } from "../../LoadingAnimation";
import { RichContent, RichHTML } from "@gisce/oficina-virtual-components";
import { useTranslation } from "react-i18next";


const Finish = ({
  onGoBack,
  type
}) => {
  const contractation = useSelector((state) => state[`${type}Contractation`]);
  const confirmResponse = contractation.steps.confirmation.confirmResponse;
  const { t } = useTranslation();

  return (
    <>      
      {contractation?.isConfirming ? (
        <LoadingAnimation />
      ) : (
        confirmResponse?.status === "OK" ? (
          confirmResponse?.result?.render?.body ? (
            confirmResponse.result.render.format === "html" ? 
            <RichHTML
              html={confirmResponse.result.render.body}
            /> : 
            <RichContent
              content={confirmResponse.result.render.body}
            />
          ) : (
          <div>
            {!contractation?.person?.company ? t('common:text.contractation_form_sent_business') : t('common:text.contractation_form_sent')}
          </div>
          )
        ) : (
          confirmResponse?.result?.error && 
            <Button
              variant={'text'}
              onClick={onGoBack}
              style={{ marginRight: 12 }}
            >
              {t('common:text.contractation_previous')}
            </Button>
        )
      )}
    </>
  );
};

export default Finish;
